import React from 'react'
import {
  SETUP_MFA_ENFORCED_TITLE,
  SETUP_MFA_ENFORCED_SUBTITLE,
  SETUP_MFA_ENFORCED_ACTION_MESSAGE,
  SETUP_MFA_ENFORCED_GENERIC_ERROR
} from '../../constants/ui.labels'
import { ContentHeader, Error } from '../../components'
import { Color, Icon } from '@cobalt/cobalt-react-components'
import { func, string } from 'prop-types'
import ActionButton from '../../components/ActionButton'
import mapError from '../../utils/mapError/mfa'

class SetupMFAEnforced extends React.PureComponent {
  static propTypes = {
    onSetupMfa: func.isRequired,
    errorCode: string
  }

  state = {
    isInProgress: false
  }

  componentDidUpdate = () =>
    this.props.errorCode && this.setState({ isInProgress: false })

  handleOnSetup = () => {
    this.setState({ isInProgress: true })
    this.props.onSetupMfa()
  }

  getErrorMessage = () =>
    this.props.errorCode &&
    mapError(this.props.errorCode, SETUP_MFA_ENFORCED_GENERIC_ERROR)

  render = () => (
    <div className="co--align-center vertical-space bottom-space">
      <Icon name={Icon.SECURITY} large color={Color.red[600]} />
      <ContentHeader
        title={SETUP_MFA_ENFORCED_TITLE}
        message={SETUP_MFA_ENFORCED_SUBTITLE}
      />
      <Error message={this.getErrorMessage()} />
      <ActionButton
        onClick={this.handleOnSetup}
        primary
        fullWidth
        isProcessing={this.state.isInProgress}
      >
        {SETUP_MFA_ENFORCED_ACTION_MESSAGE}
      </ActionButton>
    </div>
  )
}

export default SetupMFAEnforced
